import * as React from 'react';

import {
    Box,
} from "@mui/material";


import { AppLoader } from "./../components/AppLoader.tsx";
import "../styles/pages/app-loader-page.scss";

export const AppLoaderPage = () => (
    <div className="container">
        <div className="content app-loader-content">
            <Box sx={{ flexGrow: 1 }}
                display="flex"
                justifyContent="center"
                alignItems="center"
                minHeight="80vh"
            >
                <AppLoader />
            </Box>
        </div>
    </div>
);

